import { Controller } from "stimulus";

export default class extends Controller
{
    static targets = ["hidden", "input", "arrow", "dropdown", "checkbox", "selectAll", "clearAll"];
    DATA = [];
    TYPE = "double";
    TYPING = false;
    CURRENT_ACTIVE_INDEX = -1;

    connect()
    {
        this.setupDropdown(
            this.DATA,
            this.inputTarget,
            this.hiddenTarget,
            this.dropdownTarget,
            this.arrowTarget
        );

        this.selectAllTarget.addEventListener("click", e =>
        {
            let codes = Array.from(this.dropdownTarget.firstElementChild.children)
                            .map(c => c.dataset["value"])
                            .join(", ");

            this.hiddenTarget.value = codes;
            this.inputTarget.value = codes;

            Array.from(this.dropdownTarget.firstElementChild.children).forEach(c => c.querySelector("input").checked = true);
        })

        this.clearAllTarget.addEventListener("click", e =>
        {
            this.inputTarget.value = "";
            this.hiddenTarget.value = "";
            
            Array.from(this.dropdownTarget.firstElementChild.children).forEach(c => c.querySelector("input").checked = false);
        })

        this.selectAllTarget.addEventListener("keydown", e =>
        {
            if(e.key == "Enter")
            {
                this.selectAllTarget.click();
            }
        })

        this.clearAllTarget.addEventListener("keydown", e =>
        {
            if(e.key == "Enter")
            {
                this.clearAllTarget.click();
            }
        })

    }

    setupDropdown(optionData, inputField, hiddenField, dropdown, arrow)
    {
        optionData = Array.from(dropdown.firstElementChild.children).map(option =>
        {
            let main = option.lastElementChild.lastElementChild;
            this.TYPE = (main.children.length == 2) ? "double" : "single";

            let name = (this.TYPE == "single") ? main.textContent.trim() : main.lastElementChild.textContent.trim();
            return {
                name,
                code: option.dataset["value"]
            }
        });

        this.addHideDropdownEL(dropdown, inputField, arrow);

        arrow.addEventListener("click", e => 
        {
            if (arrow.firstElementChild.style.transform == "rotate(360deg)" ||
                arrow.firstElementChild.style.transform == "rotate(0deg)")
            {
                this.resetOptions(optionData,
                    inputField, hiddenField, dropdown, arrow
                );

                let checked = inputField.value.split(",").map(s => s.trim().toLowerCase());

                let selectedItems = Array.from(dropdown.firstElementChild.children)
                    .filter(child => checked.includes(child.dataset["value"].toLowerCase()));

                selectedItems.forEach(child => child.querySelector("input").checked = true);

                if(this.CURRENT_ACTIVE_INDEX != -1)
                {
                    let active = dropdown.firstElementChild.children[this.CURRENT_ACTIVE_INDEX]
                    active.classList.add("active");
                    this.scrollToElement(active, dropdown.firstElementChild);
                }

                this.openDropdown(dropdown, arrow, inputField);
            }
            else
            {
                this.closeDropdown(dropdown, arrow, inputField);
            }
        });

        Array.from(dropdown.firstElementChild.children).forEach(option =>
            option.addEventListener("click", e => this.optionClickEventHandler(
                option, optionData, e,
                inputField, hiddenField,
                dropdown, arrow
            ))
        );

        //On focus
        inputField.addEventListener("focus", e =>
        {
            if(dropdown.classList.contains("toast-invisible"))
                arrow.click();
        })

        //Tabulation
        inputField.addEventListener("keydown", e =>
        {
            // if(e.key == "Tab" || (e.key == "Tab" && e.shiftKey) && !dropdown.classList.includes("toast-invisible"))
            // {
            //     this.closeDropdown(dropdown, arrow, inputField);
            //     if(inputField.value == "") this.CURRENT_ACTIVE_ITEM = -1;
            // }
        })

        //Navigation with arrows
        inputField.addEventListener("keydown", e =>
        {
            if(e.key != "ArrowDown" && e.key != "ArrowUp") return;

            e.preventDefault();

            if(this.CURRENT_ACTIVE_INDEX != -1)
            {
                let currentElement = dropdown.firstElementChild.children[this.CURRENT_ACTIVE_INDEX];
                currentElement.classList.remove("active");
            }

            if(e.key == "ArrowDown" && this.CURRENT_ACTIVE_INDEX != dropdown.firstElementChild.children.length-1)
            {
                this.CURRENT_ACTIVE_INDEX++;
            }
            else if (e.key == "ArrowUp" && this.CURRENT_ACTIVE_INDEX != 0)
            {
                this.CURRENT_ACTIVE_INDEX--;
            }
        
            let caretPosition = inputField.value.length,
                nextElement = dropdown.firstElementChild.children[this.CURRENT_ACTIVE_INDEX];

            let dropdownScroll = dropdown.firstElementChild.scrollTop,
                yTopToTop = nextElement.getBoundingClientRect().y - dropdown.firstElementChild.getBoundingClientRect().y,
                yBottomToBottom = nextElement.getBoundingClientRect().bottom - dropdown.firstElementChild.getBoundingClientRect().bottom;

            if(yTopToTop < 0)
            {
                dropdown.firstElementChild.scrollTo({top: dropdownScroll + yTopToTop, behavior: "smooth"})
            }
            else if (yBottomToBottom > 0)
            {
                dropdown.firstElementChild.scrollTo({top: dropdownScroll + yBottomToBottom, behavior: "smooth"})
            }

            nextElement.classList.add("active");
            inputField.setSelectionRange(caretPosition, caretPosition)
            // inputField.value = selectedElement.lastElementChild.textContent;
            // hiddenField.value = selectedElement.dataset["value"];
        })

        //Escape
        inputField.addEventListener("keydown", e =>
        {
            if(e.key != "Escape") return;
            this.closeDropdown(dropdown, arrow, inputField);
        })

        //Enter
        inputField.addEventListener("keydown", e =>
        {
            if(e.key == "Enter" && !dropdown.classList.contains("toast-invisible"))
            {
                e.preventDefault();
                if(this.CURRENT_ACTIVE_INDEX != -1)
                {
                    let selectedElement = dropdown.firstElementChild.children[this.CURRENT_ACTIVE_INDEX];
                    selectedElement.click();
                }
                else this.closeDropdown(dropdown, arrow, inputField);
            }
            else if (e.key == "Enter" && dropdown.classList.contains("toast-invisible"))
            {
                e.preventDefault();

                this.resetOptions(optionData,
                    inputField, hiddenField, dropdown, arrow
                );

                let checked = inputField.value.split(",").map(s => s.trim().toLowerCase());

                let selectedItems = Array.from(dropdown.firstElementChild.children)
                    .filter(child => checked.includes(child.dataset["value"].toLowerCase()));

                selectedItems.forEach(child => child.querySelector("input").checked = true);

                if(selectedItems.length != 0) this.scrollToElement(selectedItems[0], dropdown.firstElementChild);

                this.openDropdown(dropdown, arrow, inputField);
            }
        })

        inputField.addEventListener("input", e =>
        {
            this.TYPING = true;

            this.CURRENT_ACTIVE_INDEX = -1;
            dropdown.scrollTo({ top:0, behavior: "smooth" })

            let query = inputField.value.toLowerCase();
            hiddenField.value = query;

            if (query == "")
            {
                this.closeDropdown(dropdown, arrow, inputField);
                hiddenField.value = "";
                setTimeout(() => this.resetOptions(
                    optionData, inputField,
                    hiddenField, dropdown, arrow
                ), 100);

                return;
            }
            
            let splitQuery = query.split(",").map(s => s.trim());
            let lastEntered = splitQuery[splitQuery.length - 1];

            let filteredOptions = optionData.filter(option =>
            {
                return option.name.toLowerCase().includes(lastEntered) ||
                    option.code.toLowerCase().includes(lastEntered)
            });

            if (filteredOptions.length == 0)
            {
                this.closeDropdown(dropdown, arrow, inputField);
                return;
            }

            let optionElements = filteredOptions.map(option => this.createOptionElement(
                option, optionData, inputField, hiddenField,
                dropdown, arrow
            ));

            dropdown.firstElementChild.innerHTML = "";
            dropdown.firstElementChild.append(...optionElements);
            dropdown.classList.remove("toast-invisible");
            inputField.style.borderBottomLeftRadius = "0";
            inputField.style.borderBottomRightRadius = "0";

             Array.from(dropdown.firstElementChild.children).forEach(child =>
            {
                if(splitQuery.includes(child.dataset["value"].toLowerCase()))
                {
                    child.querySelector("input").checked = true;
                }
            })
        })

        inputField.addEventListener("focusout", e =>
        {
            let query = inputField.value;
            let option = optionData.find(group => group.name == query || group.code == query);

            hiddenField.value = (option) ? option.code : query;
        })
    }

    optionClickEventHandler(option, optionData, e, inputField, hiddenField, dropdown, arrow)
    {
        let checkbox = option.querySelector("input");
        if(!checkbox.checked)
        {
            let splitQuery = inputField.value.split(",").map(s => s.trim());

            if(!splitQuery.map(s => s.toLowerCase())
                        .includes(option.dataset["value"].toLowerCase()))
            
                if(this.TYPING)
                {
                    splitQuery[splitQuery.length - 1] = option.dataset["value"];
                }
                else splitQuery.push(option.dataset["value"]);

            let checked = dropdown.querySelectorAll("input:checked");
            let value = Array.from(checked).map(check => check.closest(".item").dataset["value"]).join(", ");
            
            inputField.value = splitQuery.filter(s => s != "").join(", ")
            hiddenField.value = splitQuery.filter(s => s != "").join(", ");

            checkbox.checked = true;
        }
        else
        {
            let splitQuery = inputField.value.split(",").map(s => s.trim());
            splitQuery = splitQuery.filter(el => el.toLowerCase() != option.dataset["value"].toLowerCase());

            inputField.value = splitQuery.filter(s => s != "").join(", ")
            hiddenField.value = splitQuery.filter(s => s != "").join(", ");

            checkbox.checked = false;
        }        

        this.TYPING = false;
    }

    createOptionElement(option, optionData, inputField, hiddenField, dropdown, arrow)
    {
        let div = document.createElement("div");
        div.classList.add("item");
        div.dataset.value = option.code;

        let main = (this.TYPE == "single") ? `<span>${option.name}</span>` : `<span>${option.code}</span><span>${option.name}</span>`;

        div.innerHTML = `
            <div class="flex col-gap-3 flex-row items-center">
                <input type="checkbox" class="form-checkbox" tabindex="-1">
                <div class="flex flex-col">${main}</div>
            </div>
        `;

        div.addEventListener("click", e => this.optionClickEventHandler(
            div, optionData, e,
            inputField, hiddenField, dropdown, arrow
        ));

        return div;
    }

    resetOptions(optionData, inputField, hiddenField, dropdown, arrow)
    {
        let options = optionData.map(option => this.createOptionElement(
            option, optionData, inputField, hiddenField, dropdown, arrow
        ));
        dropdown.firstElementChild.innerHTML = "";
        dropdown.firstElementChild.append(...options);
    }

    addHideDropdownEL(dropdown, textfield, arrow)
    {
        document.addEventListener("click", e =>
        {
            if (e.target == dropdown ||
                dropdown.contains(e.target) ||
                e.target == textfield ||
                arrow.contains(e.target)
            ) return;
            else this.closeDropdown(dropdown, arrow, textfield);
        })
    }

    openDropdown(dropdown, arrow, inputField)
    {
        arrow.firstElementChild.style.transform = "rotate(180deg)";
        dropdown.classList.remove("toast-invisible");

        inputField.style.borderBottomLeftRadius = "0";
        inputField.style.borderBottomRightRadius = "0";
    }

    closeDropdown(dropdown, arrow, inputField)
    {
        dropdown.classList.add("toast-invisible");
        arrow.firstElementChild.style.transform = "rotate(0deg)";

        inputField.style.borderBottomLeftRadius = "";
        inputField.style.borderBottomRightRadius = "";
    }

    scrollToElement(element, dropdown)
    {
        let dropdownScroll = dropdown.scrollTop,
            yBottomToBottom = element.getBoundingClientRect().bottom - dropdown.getBoundingClientRect().bottom;

        dropdown.scrollTo({top: dropdownScroll + yBottomToBottom, behavior: "smooth"})
    }
}